export function formatDuration(seconds?: number | null) {
  if (!seconds || seconds < 0) return "0 分钟";
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  if (hours) return `${hours} 小时${minutes ? ` ${minutes} 分钟` : ""}`;
  return `${Math.max(1, minutes)} 分钟`;
}

export function formatTimecode(seconds?: number | null) {
  const value = Math.max(0, Math.floor(seconds || 0));
  const hours = Math.floor(value / 3600);
  const minutes = Math.floor((value % 3600) / 60);
  const secs = value % 60;
  return hours
    ? [hours, minutes, secs]
        .map((part) => String(part).padStart(2, "0"))
        .join(":")
    : [minutes, secs].map((part) => String(part).padStart(2, "0")).join(":");
}

export function formatDate(value?: string | null, withTime = false) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return new Intl.DateTimeFormat("zh-CN", {
    year: "numeric",
    month: "short",
    day: "numeric",
    ...(withTime ? { hour: "2-digit", minute: "2-digit" } : {}),
  }).format(date);
}

export function formatBytes(bytes?: number | null) {
  if (bytes === undefined || bytes === null) return "—";
  if (bytes < 1024) return `${bytes} B`;
  const units = ["KB", "MB", "GB", "TB"];
  let value = bytes / 1024;
  let index = 0;
  while (value >= 1024 && index < units.length - 1) {
    value /= 1024;
    index += 1;
  }
  return `${value.toFixed(value >= 10 ? 1 : 2)} ${units[index]}`;
}

export function initials(name?: string) {
  if (!name) return "L";
  return name.trim().slice(0, 2).toUpperCase();
}

export function errorMessage(error: unknown) {
  if (error instanceof Error) {
    const requestId =
      "requestId" in error && typeof error.requestId === "string"
        ? error.requestId
        : "";
    return `${error.message}${requestId ? `（请求号：${requestId}）` : ""}`;
  }
  return "发生未知错误，请重试";
}
